import { useEffect, useRef, useState } from 'react';
type ScreenType = 'mobile' | 'tablet' | 'desktop';
const useResize = () => {
    const [screenType, setScreenType] = useState<ScreenType>(getScreenType(window.innerWidth));
    const prevScreenWidthRef = useRef(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            const newScreenType = getScreenType(screenWidth);

            if (newScreenType !== screenType) {
                setScreenType(newScreenType);
            }

            prevScreenWidthRef.current = screenWidth;
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [screenType]);

    return screenType;
};

const getScreenType = (screenWidth) => {
    if (screenWidth < 768) {
        return 'mobile';
    } else if (screenWidth >= 768 && screenWidth < 992) {
        return 'tablet';
    } else {
        return 'desktop';
    }
};

export default useResize;
